<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' >All Vehicle VORs</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/vehicles/vor/new'><i class="fas fa-plus"></i> New</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/vehicles'><i class="fas fa-arrow-left"></i> Back</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <app-grid
entity='vehicle-vor'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
